import {
  Dialog,
  DialogContent,
} from '@mui/material';
import DialogFooter from './dialog-footer';

const DialogLayoutV2 = (props) => {
  return (
    <Dialog
      aria-labelledby="dialog-title"
      open={props.open}
      fullWidth={false}
      maxWidth={false}
      fullScreen={props.fullScreen}
      sx={{
        '& .MuiDialog-paper': {
          width: '430px',
          borderRadius: '20px',
        }
      }}
    >
      <DialogContent>
        {props.content}
      </DialogContent>
      <div className='border-b'></div>
      {props.footerProps &&
        <DialogFooter onClose={props.onClose} onSubmit={props.onSubmit} {...props.footerProps} />
      }
    </Dialog>
  )
}

export default DialogLayoutV2;
